<template>
    <vx-card title="Сверка с партнерами" id="loader">
        <div>
            <div class="vx-row mb-2">
                <div class="vx-col w-1/5 mb-1">
                    <label class="vs-input--label"> Интервал </label>
                    <date-picker range v-model="dateInterval" type="date" format="YYYY-MM-DD"
                        placeholder="Интервал времени события" :lang="'ru'" :firstDayOfWeek="1" class="date-p w-full">
                    </date-picker>
                </div>

                <div class="vx-col w-1/3 mb-1">
                    <label class="vs-input--label">
                        Пользователи
                    </label>
                    <v-select multiple :options="dicts.users" label="name" placeholder="Выберите партнеров"
                        class="w-full" v-model="form.userIds" :reduce="u => u.id">
                    </v-select>
                </div>

                <vs-button class="mt-5 mr-2" color="success" @click="loadPayoutBalances(true)" type="filled"> Получить
                </vs-button>
            </div>
        </div>

        <vs-table stripe :data="items" :max-items="pageSize" :sst="true" @sort="handleSort" class="mt-1">
            <template slot="thead">
                <vs-th sort-key="userId" class="vs-lg-3">
                    Партнер
                </vs-th>
                <vs-th sort-key="balanceDayStart" class="vs-lg-2">
                    Баланс начальный
                </vs-th>
                <vs-th sort-key="balanceDayEnd" class="vs-lg-2">
                    Баланс конечный
                </vs-th>
                <vs-th sort-key="sspFlowSum" class="vs-lg-2">
                    Доход партнера
                </vs-th>
                <vs-th sort-key="userId" class="vs-lg-2">
                    Сумма выплаты
                </vs-th>                
            </template>

            <template slot-scope="{data}">
                <vs-tr v-if="!tr.isSummary" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{ tr.userEmail }} [{{ tr.userId }}]</vs-td>
                    <vs-td>{{ tr.balanceDayStart }}</vs-td>
                    <vs-td>{{ tr.balanceDayEnd }}</vs-td>
                    <vs-td>{{ tr.sspFlowSum }}</vs-td>
                    <vs-td>{{ tr.payoutsSum }}</vs-td>
                </vs-tr>

                <vs-tr v-if="tr.isSummary" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>ИТОГО</vs-td>
                    <vs-td>{{ tr.balanceDayStart }}</vs-td>
                    <vs-td>{{ tr.balanceDayEnd }}</vs-td>
                    <vs-td>{{ tr.sspFlowSum }}</vs-td>
                    <vs-td>{{ tr.payoutsSum }}</vs-td>
                </vs-tr>
            </template>
        </vs-table>

        <vs-pagination :max="5" :total="pagesTotal" v-model="page"></vs-pagination>
    </vx-card>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import vSelect from 'vue-select';
import DatePicker from 'vue2-datepicker';
import { SweetModal, SweetModalTab } from 'sweet-modal-vue';

export default {
    data() {
        return {
            form: {
                amount: undefined,
                dateTimeFrom: undefined,
                dateTimeTo: undefined,
                payoutStatusId: undefined,
                userIds: undefined,

            },
            dicts: {
                payoutStatuses: [],
                users: []
            },
            errors: {
                amount: ''
            },

            items: [],
            dateInterval: undefined,
            page: 1,
            pageSize: 15,
            pagesTotal: 1,
            orderBy: undefined,
            isAscOrder: false,
        };
    },

    methods: {
        loadDicts() {
            this.$axios({
                url: 'payoutBalances/dicts',
                method: 'GET',
                success: (dicts) => {
                    this.dicts = dicts;
                },
                catch: (err) => {
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки справочников.',
                        color: 'danger'
                    });
                }
            });
        },
        loadPayoutBalances(reset) {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            if (reset) {
                this.page = 1;
            }

            var params = {
                dateFrom: this.form.dateTimeFrom,
                dateTo: this.form.dateTimeTo,
                payoutStatusId: this.form.payoutStatusId,
                userIds: this.form.userIds,
                page: this.page,
                size: this.pageSize,
                orderBy: this.orderBy,
                isAscOrder: this.isAscOrder
            }

            this.axios
                .all([
                    this.axios.get('payoutBalances', {
                        params: params,
                        paramsSerializer: (params) => {
                            return qs.stringify(params);
                        }
                    }),
                    this.axios.get('payoutBalances/count', {
                        params: params,
                        paramsSerializer: (params) => {
                            return qs.stringify(params);
                        }
                    })
                ])
                .then(
                    axios.spread((items, count) => {
                        this.items = items.data;
                        this.pagesTotal = Math.ceil(count.data / this.pageSize);
                    })
                )
                .catch((err) => {
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки данных.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        handleSort(key, active) {
            this.orderBy = key;
            this.isAscOrder = active == 'asc';

            this.loadPayoutBalances();
        },

        setDefaultValues() {
            let startDay = this.$moment(new Date());
            let startDayStr = startDay.format('YYYY-MM-DD');
            let endDay = startDay.add(1, 'days');
            let endDayStr = startDay.format('YYYY-MM-DD');            
            this.dateInterval = [startDayStr, endDayStr];
            this.form.dateTimeFrom = this.$moment(this.dateInterval[0]).format('YYYY-MM-DD');
            this.form.dateTimeTo = this.$moment(this.dateInterval[1]).format('YYYY-MM-DD');
        },
    },

    watch: {
        page: function () {
            this.loadPayoutBalances();
        },
        dateInterval: function (newTime) {
            this.form.dateTimeFrom = this.$moment(newTime[0]).format('YYYY-MM-DD');
            this.form.dateTimeTo = this.$moment(newTime[1]).format('YYYY-MM-DD');
        }
    },

    mounted() {
        this.setDefaultValues();
        this.loadDicts();
        this.loadPayoutBalances();
    },

    components: {
        'v-select': vSelect,
        'date-picker': DatePicker,
        SweetModal,
        SweetModalTab
    },
    beforeCreate() {
        // Установка заголовка вкладки
        document.title = 'Сверка с партнерами';
    },
};
</script>

<style lang="scss">
table {
    tr.selected {
        cursor: text !important;
    }
}

thead {
    th {
        font-size: 15px !important;

        .sort-th {
            i {
                font-size: 19px;
            }
        }
    }
}

.vs-con-table .vs-con-tbody,
.vs-table--content {
    overflow: initial;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
    -webkit-transform: none;
}

.header-title {
    flex-direction: column;
}

.textarea {
    border: 1px solid lightgrey !important;
    background-color: RGB(245, 245, 245);
}

.date-p {
    display: block;
}

.b-btn {
    border-radius: 0;
    width: 200px;
}

.vs-pagination--mb {
    justify-content: center !important;
}

.status-col {
    min-width: 190px;
}

.logs-popup .vs-popup {
    width: 1000px;
}

.vs-checkbox-col {
    width: 1% !important;
}
</style>

<style scoped>
th>>>div {
    float: right;
}

tr>>>.vs-table--td {
    border: 1px solid rgba(0, 0, 0, 0.12);
    padding: 4px 5px;
    text-align: right;
    font-family: sans-serif;
    font-size: 16px;
}

div>>>.vs-pagination-primary {
    margin-top: 10px;
}

.change-status {
    width: 200px;
}
</style>
